(function () {
  function initCartDrawer() {
  var root = document.querySelector('[data-cart-drawer-root]');
  if (!root) return;

  var bodyEl = root.querySelector('[data-cart-drawer-body]');
  var footEl = root.querySelector('[data-cart-drawer-foot]');
  var openers = document.querySelectorAll('[data-cart-drawer-open]');
  var cartUrl = root.dataset.cartUrl || '/cart';
  var cartJsUrl = root.dataset.cartJs || '/cart.js';
  var cartChangeBase = (cartUrl || '/cart').replace(/\/$/, '');
  var cartChangeUrl = cartChangeBase + '/change.js';
  var shopRoot = root.dataset.shopRoot || '/';
  var textEmpty = root.dataset.textEmpty || 'O carrinho está vazio.';
  var textContinue = root.dataset.textContinue || 'Continuar a comprar';
  var textCheckout = root.dataset.textCheckout || 'Finalizar compra';
  var lastOpener = null;
  var cartBusy = false;
  var cartClosing = false;
  var cartPanel = root.querySelector('.my_cart-drawer__panel');

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function trashIconSvg() {
    return (
      '<svg class="my_cart-drawer__trash-svg" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>' +
      '<line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/>' +
      '</svg>'
    );
  }

  function isDefaultTitleVariantValue(value) {
    return /^default\s*title$/i.test(String(value || '').trim());
  }

  function variantDetailsHtml(item) {
    var parts = [];
    if (item.options_with_values && Array.isArray(item.options_with_values)) {
      item.options_with_values.forEach(function (opt) {
        if (!opt || opt.value == null) return;
        var val = String(opt.value).trim();
        if (!val || isDefaultTitleVariantValue(val)) return;
        var name = String(opt.name || '').trim();
        if (!name) return;
        parts.push(escapeHtml(name) + ': ' + escapeHtml(val));
      });
    }
    if (parts.length) {
      return '<p class="my_cart-drawer__line-variant">' + parts.join(' · ') + '</p>';
    }
    var vt = item.variant_title;
    if (vt && vt !== 'Default Title') {
      return '<p class="my_cart-drawer__line-variant">' + escapeHtml(vt) + '</p>';
    }
    return '';
  }

  function setCartBusy(busy) {
    cartBusy = busy;
    if (busy) {
      root.classList.add('my_cart-drawer--busy');
    } else {
      root.classList.remove('my_cart-drawer--busy');
    }
  }

  function changeLineQuantity(lineKey, quantity) {
    if (cartBusy || !lineKey) return;
    setCartBusy(true);
    fetch(cartChangeUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ id: lineKey, quantity: quantity }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
      })
      .catch(function () {
        loadCart();
      })
      .finally(function () {
        setCartBusy(false);
      });
  }

  function finalizeCartClose() {
    cartClosing = false;
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    root.classList.remove('my_cart-drawer--open');
    var searchM = document.querySelector('[data-header-search-modal]');
    var menuD = document.querySelector('[data-header-drawer]');
    var keepScrollLock =
      (searchM && !searchM.hidden) || (menuD && !menuD.hidden);
    document.body.style.overflow = keepScrollLock ? 'hidden' : '';
    if (!keepScrollLock && lastOpener && typeof lastOpener.focus === 'function') {
      try {
        lastOpener.focus();
      } catch (e) {}
    }
  }

  function closeDrawer() {
    if (root.hidden || cartClosing) return;
    if (!root.classList.contains('my_cart-drawer--open')) {
      finalizeCartClose();
      return;
    }
    cartClosing = true;
    root.classList.remove('my_cart-drawer--open');
    if (prefersReducedMotion() || !cartPanel) {
      finalizeCartClose();
      return;
    }
    var finished = false;
    function done() {
      if (finished) return;
      finished = true;
      cartPanel.removeEventListener('transitionend', onEnd);
      finalizeCartClose();
    }
    function onEnd(e) {
      if (e.target !== cartPanel || e.propertyName !== 'transform') return;
      done();
    }
    cartPanel.addEventListener('transitionend', onEnd);
    window.setTimeout(done, 420);
  }

  function openDrawer() {
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    root.classList.remove('my_cart-drawer--open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        root.classList.add('my_cart-drawer--open');
      });
    });
    loadCart();
    window.setTimeout(function () {
      var closeBtn = root.querySelector('.my_cart-drawer__close');
      if (closeBtn) closeBtn.focus();
    }, 50);
  }

  function formatMoney(cents, currencyCode) {
    var v = (cents || 0) / 100;
    var cur = currencyCode || 'BRL';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
        style: 'currency',
        currency: cur,
      }).format(v);
    } catch (e) {
      return 'R$ ' + v.toFixed(2).replace('.', ',');
    }
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function escapeAttr(s) {
    return String(s || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function renderEmpty() {
    bodyEl.innerHTML =
      '<div class="my_cart-drawer__empty">' +
      '<p class="my_cart-drawer__empty-msg">' +
      escapeHtml(textEmpty) +
      '</p>' +
      '<button type="button" class="my_cart-drawer__btn my_cart-drawer__btn--primary" data-cart-drawer-close>' +
      escapeHtml(textContinue) +
      '</button>' +
      '</div>';
    footEl.hidden = true;
    footEl.innerHTML = '';
  }

  function renderCart(cart) {
    var currency = cart.currency || 'BRL';

    if (!cart.items || cart.items.length === 0) {
      renderEmpty();
      return;
    }

    var html = '<ul class="my_cart-drawer__list" role="list">';
    cart.items.forEach(function (item) {
      var imgUrl = item.image || '';
      var title = item.product_title || item.title || '';
      var lineKey = item.key || '';
      var qty = item.quantity || 0;
      html +=
        '<li class="my_cart-drawer__line" data-cart-line data-line-key="' +
        escapeAttr(lineKey) +
        '" data-quantity="' +
        escapeAttr(String(qty)) +
        '">';
      html += '<a href="' + escapeAttr(item.url) + '" class="my_cart-drawer__line-media">';
      if (imgUrl) {
        html +=
          '<img src="' +
          escapeAttr(imgUrl) +
          '" alt="' +
          escapeAttr(title) +
          '" width="72" height="72" loading="lazy">';
      } else {
        html += '<span class="my_cart-drawer__line-placeholder" aria-hidden="true"></span>';
      }
      html += '</a>';
      html += '<div class="my_cart-drawer__line-main">';
      html += '<div class="my_cart-drawer__line-info">';
      html +=
        '<a href="' +
        escapeAttr(item.url) +
        '" class="my_cart-drawer__line-title">' +
        escapeHtml(title) +
        '</a>';
      html +=
        '<p class="my_cart-drawer__line-price">' +
        formatMoney(item.final_line_price, currency) +
        '</p>';
      html += variantDetailsHtml(item);
      html += '</div>';
      html += '<div class="my_cart-drawer__line-actions">';
      html +=
        '<button type="button" class="my_cart-drawer__line-remove" data-cart-line-remove data-line-key="' +
        escapeAttr(lineKey) +
        '" aria-label="Remover item">' +
        trashIconSvg() +
        '</button>';
      html += '<div class="my_cart-drawer__qty" role="group" aria-label="Quantidade">';
      html +=
        '<button type="button" class="my_cart-drawer__qty-btn" data-cart-line-qty data-line-key="' +
        escapeAttr(lineKey) +
        '" data-delta="-1" aria-label="Diminuir quantidade">−</button>';
      html +=
        '<span class="my_cart-drawer__qty-val" aria-live="polite">' +
        escapeHtml(String(qty)) +
        '</span>';
      html +=
        '<button type="button" class="my_cart-drawer__qty-btn" data-cart-line-qty data-line-key="' +
        escapeAttr(lineKey) +
        '" data-delta="1" aria-label="Aumentar quantidade">+</button>';
      html += '</div></div></div></li>';
    });
    html += '</ul>';
    bodyEl.innerHTML = html;

    footEl.hidden = false;
    footEl.innerHTML =
      '<div class="my_cart-drawer__subtotal">' +
      '<span>Subtotal</span> ' +
      '<strong>' +
      formatMoney(cart.total_price, currency) +
      '</strong></div>' +
      '<form action="' +
      escapeAttr(cartUrl) +
      '" method="post">' +
      '<button type="submit" name="checkout" class="my_cart-drawer__btn my_cart-drawer__btn--checkout">' +
      escapeHtml(textCheckout) +
      '</button></form>' +
      '<a href="' +
      escapeAttr(shopRoot) +
      '" class="my_cart-drawer__link-continue">' +
      escapeHtml(textContinue) +
      '</a>';
  }

  function loadCart() {
    bodyEl.innerHTML = '<p class="my_cart-drawer__loading">A carregar…</p>';
    fetch(cartJsUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        renderCart(cart);
      })
      .catch(function () {
        bodyEl.innerHTML =
          '<p class="my_cart-drawer__error">Não foi possível carregar o carrinho.</p>';
        footEl.hidden = true;
      });
  }

  root.addEventListener('click', function (e) {
    var closeEl = e.target.closest('[data-cart-drawer-close]');
    if (closeEl && root.contains(closeEl)) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    if (cartBusy) return;

    var qtyBtn = e.target.closest('[data-cart-line-qty]');
    if (qtyBtn && bodyEl.contains(qtyBtn)) {
      e.preventDefault();
      var qKey = qtyBtn.getAttribute('data-line-key');
      var delta = parseInt(qtyBtn.getAttribute('data-delta'), 10);
      var li = qtyBtn.closest('[data-cart-line]');
      var cur = li ? parseInt(li.getAttribute('data-quantity'), 10) : 0;
      if (isNaN(cur)) cur = 0;
      if (isNaN(delta)) return;
      var next = cur + delta;
      if (next < 0) next = 0;
      changeLineQuantity(qKey, next);
      return;
    }

    var rm = e.target.closest('[data-cart-line-remove]');
    if (rm && bodyEl.contains(rm)) {
      e.preventDefault();
      changeLineQuantity(rm.getAttribute('data-line-key'), 0);
      return;
    }
  });

  openers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (e.button !== 0) return;
      e.preventDefault();
      lastOpener = el;
      openDrawer();
    });
  });

  document.addEventListener('bach:open-cart-drawer', function (ev) {
    var d = ev && ev.detail;
    lastOpener = (d && d.opener) || null;
    openDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (e.defaultPrevented) return;
    if (root.hidden) return;
    var searchModal = document.querySelector('[data-header-search-modal]');
    if (searchModal && !searchModal.hidden) return;
    var navDrawer = document.querySelector('[data-header-drawer]');
    if (navDrawer && !navDrawer.hidden && navDrawer.classList.contains('my_header__drawer--open')) return;
    closeDrawer();
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }
})();
